import { render, staticRenderFns } from "./RapidFormSuggestionWidget.vue?vue&type=template&id=60e19c81"
import script from "./RapidFormSuggestionWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./RapidFormSuggestionWidget.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports